module.exports = __webpack_public_path__ + "static/media/proceso_comercial.b44254be.jpg";